<template>
  <div class="page">
    <div id="page-header" class="page-header">
      <h2 class="page-header__title">お申込み完了</h2>
    </div>
    <div id="page-content" class="page-content">
      <article>
        <section>
          <p>
            お客様のお申込みを受付致しました。<br />
            お申込み確認メールをお送り致しますので、数時間経ってもメールの確認ができない場合は、受講ダイブセンターもしくはインストラクターまでお問い合わせください。<br />
          </p>
          <h4 class="page-content__article-section-title--dialog-red">
            【注意事項】※かならずご確認ください。
          </h4>
          <div class="page-content__article-section-body--noindent">
            <ul>
              <li>
                メールアドレスによっては、<span class="page-content__ul--red"
                  >迷惑メールフォルダに振り分けられる可能性があります</span
                >ので、お手数ですがご確認をお願いいたします。
              </li>
              <li>
                受講期限について、受講ダイブセンターもしくはインストラクターに事前に確認をしておいてください。
              </li>
              <li>
                <span class="page-content__ul--red"
                  >健康チェックで所定の質問に回答があった場合、実技講習の受講前に医師の診断が必要となります。</span
                >医師の診断の後、コース受講が認められない場合は、お客様のお申込みをお断りさせて頂きます。また、医師の診断書が確認出来ない場合、受講をお断りする場合がございますので、あらかじめご了承の程よろしくお願い致します。
              </li>
            </ul>
          </div>
        </section>
      </article>
    </div>
    <div id="page-footer" class="page-footer">
      <div class="page-footer__next-button-wrapper">
        <div class="page-footer__next-button-inner">
          <router-link to="/" custom v-slot="{ navigate }">
            <button id="nextButton" class="btn btn-danger rounded-pill" @click="navigate">
              コース申込トップ画面に戻る
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    /**
     * 選択した支払方法を取得する
     */
    payBy: function () {
      if (this.$store.getters['courseApplication/registerResponse'] === null) {
        return '';
      }
      return this.$store.getters['courseApplication/registerResponse'].payBy;
    },
    /**
     * 取得したリダイレクトURLを取得する
     */
    redirectUrl: function () {
      if (this.$store.getters['courseApplication/registerResponse'] === null) {
        return '';
      }
      return this.$store.getters['courseApplication/registerResponse'].redirectUrl;
    },
  },
  destroyed() {
    // ストアに保存した内容をクリアする
    if (process.env.RAILS_ENV !== 'development') {
      this.$store.commit('courseApplication/reset');
    }
  },
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/page.scss';

.page-content__important-sentense {
  color: red;
  font-weight: bold;
}

.page-content__creditcard-section {
  margin: 1rem 1rem 1rem 1rem;
  padding: 1rem 1rem 1rem 1rem;
  text-align: center;
  border: solid 1px #7d7d7d;
}
</style>
